<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('listeAudit.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="is-pulled-right buttons boutonAction">
              <a class="button is-addOrEdit"
                 @click="checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.maj)
          ? $router.push({ name: 'm.logistique.ordre_travail_audit-add'}) : showPopUp()"
                 :class="{'button-access-no-permission' :
               !checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.maj) }">
                {{ $t('listeAudit.actions.add')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px level">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="manageActions"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllAuditSelected().length > 0"
          ></selecteur-action>
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class="column is-narrow">
          <button class="button" @click="setShowFiltre">
            <b-icon icon="filter-variant" size="is-small" type="is-default"/>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span
            class="info-circle-right is-pulled-right is-cursor-pointer"
            @click="reinitialiserFiltre()">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.PERM_AUDIT_TECHNIQUE.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="code" slot-scope="props">
        <router-link
          :to="{ name: 'c.logistique.ordre_travail_audit', params: { id: props.row.id } }"
          class="lien"
          :class="{'text-access-no-permission':
          !checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="etat" slot-scope="props" >
        {{ getLibelleEtat(props.row.etat )}}
      </div>
      <div slot="dateRealisation" slot-scope="props" >
        {{ props.row.dateRealisation | formatDate }}
      </div>
      <div slot="dateSouhaitee" slot-scope="props" >
        {{ props.row.dateSouhaitee | formatDate }}
      </div>
      <div slot="datePlanification" slot-scope="props" >
        {{ props.row.datePlanification | formatDate }}
      </div>
      <div slot="auditeurId" slot-scope="props">
        {{ getUserName(props.row.auditeurId) }}
      </div>
      <div slot="nbDispositif" slot-scope="props">
        <div class="is-pulled-right">
        {{ props.row.otPatrimoineAudit.nbDispositifs }}
        </div>
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
      <div slot="edit" slot-scope="props">
        <router-link
          :to="{ name: 'm.logistique.ordre_travail_audit-edit', params: { id: props.row.id} }">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.maj) }"></b-icon>
        </router-link>
      </div>
      <div slot="archive" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{ 'text-access-no-permission' :
            !checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.supprimer)
        ? deleteOneAudit(props.row.id) : showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PERM_AUDIT_TECHNIQUE.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre">
      <filtre-liste-audit
        ref="filtreListeAudit"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="messageHeader"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="resetAction"
        @yes="deleteAudits"/>
    </b-modal>
    <b-modal v-model="popUpEtat" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="messageHeader"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="resetAction"
        @yes="updateEtat"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import {
  ORDRE_TRAVAIL_AUDIT as PERM_AUDIT_TECHNIQUE,
} from '@/configuration/logistique/permissionsLogistiqueConf';
import inProgress from '@/services/general/inProgress';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatDate from '@/services/general/formatIsoDate';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  LIST_ETAT_AUDIT, ETAT_PLANIFIE,
  ETAT_REALISE, ETAT_EN_COURS,
  EXPORT_EXCEL_AUDIT_TECHNIQUE,
  ETAT_CLOTURER,
} from '@/configuration/logistique/audit/auditConf';
import genererCritereRecherche
  from '@/services/logistique/audit/genererObject/genererCritereRecherche';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  ACTION_DELETE,
  ACTION_MASS_REALISATION,
  ACTION_MASS_PLANIFIE,
  ACTION_MASS_EN_COURS,
  ACTION_MASS_CLOTURER,
} from '@/configuration/general/actionsConf';
import { deleteAll, updateEtatAsync, clotureDecloture } from '@/api/logistique/audit';
import validation from '@/services/logistique/audit/validation/validation';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import filtreListeAudit from '@/components/logistique/audit/liste/filtreListeAudit';
import transformer from '@/services/logistique/audit/dataTransformer';
import { columnsSplice } from '@/services/general/columns';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_AUDIT } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Audit = createNamespacedHelpers('audit');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      unsubscribeValue: null,
      showFiltre: false,
      actions: [
        { action: ACTION_MASS_PLANIFIE, translation: 'listeAudit.actions.planifie' },
        { action: ACTION_MASS_REALISATION, translation: 'listeAudit.actions.realise' },
        { action: ACTION_MASS_EN_COURS, translation: 'listeAudit.actions.enCours' },
        { action: ACTION_MASS_CLOTURER, translation: 'listeAudit.actions.cloturer' },
        { action: ACTION_DELETE, translation: 'general.button.delete' },
      ],
      startArrayRendering: false,
      mountedLoadingEnd: false,
      popUpSuppression: false,
      popUpEtat: false,
      messageHeader: null,
      etatAchanger: null,
      messagesErreurPopUp: [],
      errorPopUp: false,
      ids: [],
      constantes: {
        PERM_AUDIT_TECHNIQUE,
      },
      referenceTable: REFERENCE_TABLE_AUDIT,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    selecteurAction,
    TableItemsInView,
    popUpPrevention,
    filtreListeAudit,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Audit.mapGetters({
      audits: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeAudit.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    nombreCritere() {
      const banCritere = ['dates', 'datesPremierAffichage', 'datesValidite', 'auto', 'showOtSansDate'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.datesPremierAffichage) {
        nbCritere += this.critereRecherche.datesPremierAffichage.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.datesPremierAffichage.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.dates) {
        nbCritere += this.critereRecherche.dates.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.dates.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.datesValidite) {
        nbCritere += this.critereRecherche.datesValidite.dateDebut ? 1 : 0;
        nbCritere += this.critereRecherche.datesValidite.dateFin ? 1 : 0;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeAudit.tabs.code'),
          etat: this.$t('listeAudit.tabs.etat'),
          auditeurId: this.$t('listeAudit.tabs.auditeur'),
          dateSouhaitee: this.$t('listeAudit.tabs.dateSouhaite'),
          datePlanification: this.$t('listeAudit.tabs.datePlanification'),
          dateRealisation: this.$t('listeAudit.tabs.dateRealisation'),
          agence: this.$t('listeAudit.tabs.agence'),
          titre: this.$t('listeAudit.tabs.titre'),
          nbDispositif: this.$t('listeAudit.tabs.nbDispositif'),
          edit: '',
          archive: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.datesPremierAffichage) {
            data.query.datesPremierAffichage.dateDebut = formatDate(
              data.query.datesPremierAffichage.dateDebut,
            );
            data.query.datesPremierAffichage.dateFin = formatDate(
              data.query.datesPremierAffichage.dateFin,
            );
          }
          if (data.query.dates) {
            data.query.dates.dateDebut = formatDate(data.query.dates.dateDebut);
            data.query.dates.dateFin = formatDate(data.query.dates.dateFin);
          }
          if (data.query.datesValidite) {
            data.query.datesValidite.dateDebut = formatDate(data.query.datesValidite.dateDebut);
            data.query.datesValidite.dateFin = formatDate(data.query.datesValidite.dateFin);
          }
          if (!data.query.agencesId || data.query.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadAudit(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.audits,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          archive: 'colonneSelected',
          edit: 'colonneSelected',
        },
        sortable: ['code', 'titre', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'auditeurId'],
      };
    },
    iconSelectTotal() {
      if (this.allAuditSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = ['selected', 'code', 'titre', 'etat', 'auditeurId', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'nbDispositif', 'agence', 'edit', 'archive', 'delete'];
      if (this.agencesSelectionnees.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    allAuditSelected() {
      return this.getAllAuditSelected().length === this.audits.length
        && this.audits.length > 0;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_AUDIT_TECHNIQUE,
        typeExport: '',
        filtres: {
          query: transformer(this.lastPayload),
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Audit.mapActions({
      loadAudit: 'loadAudit',
      setCritereRecherche: 'setCritereRecherche',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    resetAction() {
      this.popUpSuppression = false;
      this.popUpEtat = false;
      this.messageHeader = null;
      this.etatAchanger = null;
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      this.ids = [];
    },
    deleteOneAudit(id) {
      this.ids = [id];
      this.messageHeader = this.$i18n.t('listeAudit.actionPopUp.supprimerAudit');
      this.popUpSuppression = true;
    },
    async deleteAudits() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAll({ otIds: this.ids });
        this.resetAction();
        this.recherche();
        loadingComponent.close();
        messageSucces(this.$t('listeAudit.messages.success.delete'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async updateEtat() {
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        switch (this.etatAchanger) {
          case ETAT_CLOTURER:
            await clotureDecloture({ ids: this.ids, cloture: true });
            break;
          default:
            await updateEtatAsync({ otsIds: this.ids, etatSouhaite: this.etatAchanger });
            break;
        }
        this.resetAction();
        this.recherche();
        loadingComponent.close();
        messageSucces(this.$t('listeAudit.messages.success.updateEtat'));
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp, this.audits);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeAudit.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeAudit.initializeFiltre();
      this.$refs.filtreListeAudit.viderCritere();
      this.$refs.filtreListeAudit.appliquerCritere();
      this.showFiltre = false;
    },
    getAllAuditSelected() {
      return this.audits.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allAuditSelected;
      this.audits.forEach(item => { item.selected = select; });
    },
    async makeRechercheFilter() {
      if (this.showFiltre) await this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.setCritereRecherche(genererCritereRecherche());
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getLibelleEtat(etatAudit) {
      const etatFind = LIST_ETAT_AUDIT.find((etat) => {
        return etat.code === etatAudit;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    getUserName(auditeurId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === auditeurId;
      });
      return userFind ? userFind.decorator.nomPrenom : null;
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    manageActions(action) {
      this.resetAction();
      this.ids = [...new Set(this.getAllAuditSelected().map(audit => audit.id))];
      switch (action) {
        case ACTION_DELETE:
          this.popUpSuppression = true;
          this.messageHeader = this.$i18n.t('listeAudit.actionPopUp.supprimerAuditMulti');
          break;
        case ACTION_MASS_EN_COURS:
          this.popUpEtat = true;
          this.etatAchanger = ETAT_EN_COURS;
          this.messageHeader = this.$i18n.t('listeAudit.actionPopUp.encoursAudit');
          break;
        case ACTION_MASS_PLANIFIE:
          this.popUpEtat = true;
          this.etatAchanger = ETAT_PLANIFIE;
          this.messageHeader = this.$i18n.t('listeAudit.actionPopUp.planifierAudit');
          break;
        case ACTION_MASS_REALISATION:
          this.popUpEtat = true;
          this.etatAchanger = ETAT_REALISE;
          this.messageHeader = this.$i18n.t('listeAudit.actionPopUp.realiserAudit');
          break;
        case ACTION_MASS_CLOTURER:
          this.popUpEtat = true;
          this.etatAchanger = ETAT_CLOTURER;
          this.messageHeader = this.$i18n.t('listeAudit.actionPopUp.cloturerAuditMulti');
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('general.noActionSelect'));
          break;
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageLogistique.audit.liste'));
      await this.loadParametreUtilisateur();
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
